// Axios client with cookie + bearer token support
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const BASE = BACKEND;

let _token = null;
export function setToken(token) {
  _token = token;
  if (token) localStorage.setItem("turkads_token", token);
  else localStorage.removeItem("turkads_token");
}
export function getToken() {
  if (_token) return _token;
  const t = localStorage.getItem("turkads_token");
  if (t) _token = t;
  return _token;
}

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers["Authorization"] = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
